<template>
  <div>
    <div class="editable-checklist-question">
      <div
        v-if="editing && editable"
        class="question-wrap"
      >
        <div
          v-if="quesNum"
          class="question-title-wrap edit"
        >
          <div class="left">
            <p class="num">
              {{ quesNum }}
            </p>
          </div>
        </div>
      </div>
      <div
        v-else
        class="question-wrap"
      >
        <div
          class="question-title-wrap"
          :class="{edit:dropDown,active:dropDown}"
          @click="dropDownToggle()"
        >
          <div class="left">
            <div class="title">
              <p
                v-if="quesNum"
                class="num"
              >
                {{ quesNum }}
              </p>
            </div>
            <div
              v-if="!dropDown"
              class="question-title"
            >
              <p class="question-title_title">
                {{ value.title }}
              </p>
              <p
                v-if="value.subtitle"
                class="question-title_subtitle"
              >
                {{ value.subtitle }}
              </p>
              <div
                v-if="isError && errorMessage.length"
                class="mt-12"
              >
                <p
                  v-for="(message,index) in errorMessage"
                  :key="index"
                  class="warning"
                >
                  <i class="icon-info" />
                  {{ message }}
                </p>
              </div>
            </div>
          </div>
          <div class="right">
            <contentChip
              v-if="editingContent.focus===1 && !hideFocus"
              medium-blue
              :text-label="$t('重點關注')"
            />
            <i
              v-if="dropDown && editable"
              class="icon-unfold-less"
            />
            <i
              v-else-if="!dropDown && editable"
              class="icon-unfold-more"
            />
            <i
              v-else
              class="icon-drag"
            />
          </div>
        </div>
        <slide-up-down
          :active="dropDown"
          :duration="500"
        >
          <div
            v-if="editable"
            class="question-container"
          >
            <ValidationObserver
              ref="formObserver"
              v-slot="{invalid}"
            >
              <LlValidateWatcher
                :errors="invalid"
                @input="$_isError($event)"
              />
              <InputListCard>
                <div class="input-item">
                  <div class="input-title-wrap">
                    <p>{{ titleAreaTitle }}<span>*</span></p>
                    <p class="gray">
                      {{ titleLength(editingContent.title) }}/300
                    </p>
                  </div>
                  <div class="input">
                    <StateInputButton
                      v-model="editingContent.title"
                      text-length="300"
                      placeholder="輸入"
                      rules="required|max:300"
                    />
                  </div>
                </div>
                <div
                  v-if="!hideToggleFocus"
                  class="input-item"
                >
                  <p class="input-title">
                    {{ $t('重點關注') }}<span>*</span>
                  </p>
                  <div class="input">
                    <RadioButton
                      v-model="editingContent.focus"
                      is-narrow
                      row
                      tablet-column
                      :radio-button-item="focusRadio"
                      :radio-name="radioName"
                    />
                  </div>
                </div>
                <div
                  v-if="editableQuesType"
                  class="input-item"
                >
                  <p class="input-title">
                    {{ $t('題型') }}<span>*</span>
                  </p>
                  <div class="input">
                    <RadioButton
                      v-model="editingContent.quesType"
                      is-narrow
                      row
                      tablet-column
                      :radio-button-item="quesTypeRadio"
                      :radio-name="typeRadioName"
                    />
                  </div>
                </div>
                <div
                  v-if="editingContent.quesType === 1"
                  class="range-input "
                >
                  <WsStateRangeInput001
                    class="mt-20"
                    :range-data="editingContent.controlLimitData"
                    :lower-limit="parseFloat(editingContent.specLimitData.lower)"
                    :upper-limit="parseFloat(editingContent.specLimitData.upper)"
                    :lower-data-placeholder="$t('輸入下限')"
                    :upper-data-placeholder="$t('輸入上限')"
                    :custom-messages="controlLimitCustomMessages"
                    :title="$t('Control Limit (管制界線)')"
                    :popup-title="$t('管制界線設定建議')"
                  />
                  <WsStateRangeInput001
                    class="mt-20 mb-20"
                    :range-data="editingContent.specLimitData"
                    :lower-data-placeholder="$t('輸入下限')"
                    :upper-data-placeholder="$t('輸入上限')"
                    :custom-messages="specLimitCustomMessages"
                    :title="$t('Spec Limit (合規界線)')"
                    :popup-title="$t('合規界線設定建議')"
                  />
                </div>
                <div
                  v-if="textLabel"
                  class="input-item"
                >
                  <p class="input-title">
                    {{ textLabel }}<span>*</span>
                  </p>
                  <div class="input">
                    <WsInputTextareaButton001
                      v-model="editingContent.remark"
                      :min-height="134"
                      :placeholder="textareaPlaceholder"
                      rules="required"
                    />
                  </div>
                </div>
                <div
                  v-if="!nonFileUpload"
                  class="input-item"
                >
                  <p class="input-title">
                    {{ attachTitle }}
                  </p>
                  <div class="file-list">
                    <div
                      v-for="(attach,attachIndex) in editingContent.attaches"
                      :key="attachIndex"
                      class="file"
                    >
                      <FileDownloadButton
                        upload
                        :text-label="attach.url"
                        :isloading="attach.isloading"
                        @deleteFile="deleteFile(attach)"
                      />
                    </div>
                    <div class="file">
                      <UploadFileButton
                        v-model="editingContent.attaches"
                        multiple
                        :upload-url="uploadFileUrl"
                        :factory="factory"
                      />
                    </div>
                  </div>
                </div>
                <div
                  v-if="ocapEdit"
                  class="input-item"
                >
                  <p class="input-title">
                    {{ textLabelOcap }}
                  </p>
                  <div class="input">
                    <WsInputTextareaButton001
                      v-model="editingContent.ocapRemark"
                      :min-height="134"
                      :placeholder="$t('輸入')"
                    />
                  </div>
                </div>
                <div
                  v-if="ocapEdit"
                  class="input-item"
                >
                  <p class="input-title">
                    {{ attachTitleOcap }}
                  </p>
                  <div class="file-list">
                    <div
                      v-for="(attach,attachIndex) in editingContent.ocapAttaches"
                      :key="attachIndex"
                      class="file"
                    >
                      <FileDownloadButton
                        upload
                        :text-label="attach.url"
                        :isloading="attach.isloading"
                        @deleteFile="deleteFile(attach,'ocap')"
                      />
                    </div>
                    <div class="file">
                      <UploadFileButton
                        v-model="editingContent.ocapAttaches"
                        multiple
                        :upload-url="uploadFileOcapUrl"
                        :factory="factory"
                      />
                    </div>
                  </div>
                </div>
                <slot />
              </InputListCard>
            </ValidationObserver>
          </div>
        </slide-up-down>
      </div>
      <div
        v-if="!editing && editable"
        class="edit-tool"
      >
        <WsTextButton001
          leading-icon="icon-delete"
          red
          font-size-xs
          no-padding
          @click="deleteQues()"
        >
          {{ $t('刪除') }}
        </WsTextButton001>
        <WsTextButton001
          v-if="!nonCopyBtn"
          leading-icon="icon-copy"
          primary
          font-size-xs
          no-padding
          @click="copyQuesClick()"
        >
          {{ $t('複製') }}
        </WsTextButton001>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EditableChecklistQuestion",
  props: {
    textareaPlaceholder: {
      type: String,
      default() {
        return this.$t("輸入");
      },
    },
    nonFileUpload: {
      type: Boolean,
      default: false,
    },
    nonCopyBtn: {
      type: Boolean,
      default: false,
    },
    titleAreaTitle: {
      type: String,
      default() {
        return this.$t("標題");
      },
    },
    hideToggleFocus: {
      type: Boolean,
      default: false,
    },
    ocapEdit: {
      type: Boolean,
      default: false,
    },
    hideFocus: {
      type: Boolean,
      default: false,
    },
    radioName: {
      type: String,
      default: "",
    },
    typeRadioName: {
      type: String,
      default: "",
    },
    select: {
      type: Boolean,
      default: false,
    },
    textLabel: {
      type: String,
      default: "",
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    editable: {
      type: Boolean,
      default: false,
    },
    risk: {
      type: String,
      default: "",
    },
    quesNum: {
      type: Number,
      default: 0,
    },
    uploadImageUrl: {
      type: String,
      default: "",
    },
    uploadFileUrl: {
      type: String,
      default: "",
    },
    factory: {
      type: String,
    },
    subtitle: {
      type: String,
      default: "",
    },
    chapterNum: {
      type: Number,
      default: 0,
    },
    sectionNum: {
      type: Number,
      default: 0,
    },
    focus: {
      type: Number,
      default: 0,
    },
    editableQuesType: {
      type: Boolean,
      default: false,
    },
    attachTitle: {
      type: String,
      default: "",
    },
    textLabelOcap: {
      type: String,
      default: "OCAP",
    },
    attachTitleOcap: {
      type: String,
      default() {
        return this.$t("OCAP附件");
      },
    },
    uploadFileOcapUrl: {
      type: String,
      default: "",
    },
    copyDropDown: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isError: false,
      dropDown: false,
      editing: false,
      errorMessage: [],
      inputQuestionTitle: "",
      inputQuestionContent: "",
      focusRadio: {
        buttonItems: [
          {
            id: 1,
            value: "true",
            textLabel: this.$t("是"),
          },
          {
            id: 0,
            value: "false",
            textLabel: this.$t("否"),
          },
        ],
      },
      quesTypeRadio: {
        buttonItems: [
          {
            id: 2,
            value: "quality",
            textLabel: this.$t("質性"),
          },
          {
            id: 1,
            value: "quantity",
            textLabel: this.$t("量性"),
          },
        ],
      },
      editingContent: {},
      controlLimitCustomMessages: {
        customedMinValue: this.$t("管制界線下限不可小於合規界線"),
        customedMaxValue: this.$t("管制界線上限不可大於合規界線"),
        max_value: this.$t("管制界線下限不可大於管制界線上限"),
        min_value: this.$t("管制界線上限不可小於管制界線下限"),
      },
      specLimitCustomMessages: {
        customedMinValue: this.$t("合規界線下限不可大於管制界線"),
        customedMaxValue: this.$t("合規界線上限不可小於管制界線"),
        max_value: this.$t("合規界線下限不可大於合規界線上限"),
        min_value: this.$t("合規界線上限不可小於合規界線下限"),
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        this.editingContent = this.value;
      },
    },
    editingContent: {
      immediate: true,
      deep: true,
      handler() {
        this.$emit("input", this.editingContent);
      },
    },
  },

  mounted() {
    this.startEdit();
    this.dropDownOpen();
    this.editingContent = JSON.parse(JSON.stringify(this.value));
    this.focusRadio.selected_condition = this.focus;
  },
  methods: {
    dropDownToggle() {
      if (this.editable) {
        this.dropDown = !this.dropDown;
      }
    },
    dropDownOpen() {
      if (this.copyDropDown) {
        this.dropDown = true;
      }
    },
    editOpen() {
      this.startEdit();
      this.editing = true;
    },
    editClose() {
      this.editing = false;
    },
    deleteImg(index) {
      this.editingContent.images.splice(index, 1);
    },
    deleteFile(index, type = null) {
      if (type === "ocap") {
        this.editingContent.ocapAttaches.splice(index, 1);
      } else {
        this.editingContent.attaches.splice(index, 1);
      }
    },
    previewFile() {
      this.$emit("previewFile");
    },
    titleLength(text) {
      if (!text) return 0;
      return text.length;
    },
    deleteQues() {
      this.$emit("delete");
    },
    copyQuesClick() {
      this.$emit("copy-click");
    },
    startEdit() {
      this.editingContent = JSON.parse(JSON.stringify(this.value));
    },
    async $_submitClick() {
      const isValidate = await this.$refs.formObserver.validate();
      if (!isValidate) {
        this.errorMessage = [`${this.$t("必填資料尚未填寫完整")}`];
      } else {
        this.errorMessage = [];
      }
    },
    $_isError($event) {
      this.isError = $event;
      if (this.isError) {
        this.errorMessage = [`${this.$t("必填資料尚未填寫完整")}`];
      } else {
        this.errorMessage = [];
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/editable-checklist-question";
</style>